export const RefLayers = {
  "Recreational Fishing Operators":
    "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/MOW_OECS_Model_Reference_Layers_04072021_WFL1/FeatureServer/0",
  "Whale and Dolphin Watching Operators":
    "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/MOW_OECS_Model_Reference_Layers_04072021_WFL1/FeatureServer/1",
  "Birdwatching Hotspots (Points)":
    "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/MOW_OECS_Model_Reference_Layers_04072021_WFL1/FeatureServer/2",
  "Birdwatching Hotspots (Areas)":
    "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/MOW_OECS_Model_Reference_Layers_04072021_WFL1/FeatureServer/3",
  "Protected Areas":
    "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/MOW_OECS_Model_Reference_Layers_04072021_WFL1/FeatureServer/4",
  "Important Bird Areas (IBA)":
    "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/MOW_OECS_Model_Reference_Layers_04072021_WFL1/FeatureServer/5",
  "Bathymetric Contours (100m intervals)":
    "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/MOW_OECS_Model_Reference_Layers_04072021_WFL1/FeatureServer/6",
  "Ports & Marinas":
    "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/MOW_OECS_Model_Reference_Layers_04072021_WFL1/FeatureServer/7",
  "Exclusive Econmic Zones (EEZ)":
    "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/MOW_OECS_Model_Reference_Layers_04072021_WFL1/FeatureServer/8",
  "Mangroves (TNC, 2013)":
    "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/MOW_OECS_Model_Reference_Layers_04072021_WFL1/FeatureServer/9",
  Paddlesports:
    "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/MOW_OECS_Model_Reference_Layers_04072021_WFL1/FeatureServer/10",
  "Seafood Restaurants":
    "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/MOW_OECS_Model_Reference_Layers_04072021_WFL1/FeatureServer/11",
  "Areas of Conservation Importance":
    "https://services.arcgis.com/F7DSX1DSNSiWmOqh/arcgis/rest/services/Birdwatching_Areas_of_Conservation_Importance_WFL1/FeatureServer",
  "Population Analysis - Number of People":
    "https://services2.coastalresilience.org/arcgis/rest/services/OceanWealth/OECS/MapServer",
    "Population Analysis - Number of Women":
    "https://services2.coastalresilience.org/arcgis/rest/services/OceanWealth/OECS/MapServer",
    "Population Analysis - Number of Elderly":
    "https://services2.coastalresilience.org/arcgis/rest/services/OceanWealth/OECS/MapServer",
    "Population Analysis - Number of Children":
    "https://services2.coastalresilience.org/arcgis/rest/services/OceanWealth/OECS/MapServer",
};
